import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { descargarArchivo } from '@/lib/api';
import { useSession } from '@/store/SessionContext';

export function Resultado() {
  const navigate = useNavigate();
  const { ultimoRender, seleccion } = useSession();
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!ultimoRender) {
    return (
      <div className="ld-card">
        <h2 className="ld-card__title">Nada generado todavía</h2>
        <p className="ld-card__hint">Genera un vídeo o una imagen desde el editor.</p>
        <button type="button" className="ld-btn ld-btn--primary" onClick={() => navigate('/')}>
          Ir al inicio
        </button>
      </div>
    );
  }

  const { url, kind, filename } = ultimoRender;

  async function onDownload() {
    setError(null);
    setDownloading(true);
    try {
      await descargarArchivo(url, filename);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setDownloading(false);
    }
  }

  return (
    <div className="ld-stack ld-stack--lg">
      <div className="ld-card">
        <div className="ld-spread">
          <div>
            <p className="muted mono" style={{ margin: 0, fontSize: 11, letterSpacing: '0.06em' }}>
              SALIDA · {kind.toUpperCase()}
            </p>
            <h2 className="ld-card__title" style={{ margin: '4px 0 0' }}>
              {kind === 'video' ? 'Vídeo Stories 9:16' : 'Imagen 16:9 (X/Twitter)'}
            </h2>
          </div>
          {seleccion ? (
            <button type="button" className="ld-btn ld-btn--ghost ld-btn--small" onClick={() => navigate('/editor')}>
              ← Volver al editor
            </button>
          ) : null}
        </div>
      </div>

      <div className="ld-card">
        <div className="ld-stack">
          {kind === 'video' ? (
            <video src={url} controls style={{ width: '100%', maxWidth: 360, borderRadius: 12 }} />
          ) : (
            <img src={url} alt="resultado" style={{ width: '100%', maxWidth: 720, borderRadius: 12 }} />
          )}
          <div className="ld-row">
            <button type="button" className="ld-btn ld-btn--primary" onClick={onDownload} disabled={downloading}>
              {downloading ? 'Descargando…' : `Descargar ${kind === 'video' ? 'MP4' : 'PNG'}`}
            </button>
          </div>
          {error ? (
            <div className="ld-login__error" style={{ marginTop: 4 }}>
              {error}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
